import {
  ADD_CONTACT,
  ADDING_PARTNER_CONTACT,
  ADD_PARTNER_CONTACT,
  UPDATE_CONTACT,
  FIND_CONTACT,
} from '../actions/actionTypes';

const INITIAL_STATE = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  subjectSelection: '',
  message: '',
  usersId: null,
  loading: false,
  isSubmitted: false,
};
export const contactReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FIND_CONTACT:
      return {
        ...state,
        email: action.payload,
        loading: false,
      };
    case ADD_CONTACT:
      return {
        ...state,
        body: action.payload,
        loading: false,
      };
    case ADDING_PARTNER_CONTACT:
      return {
        ...state,
        loading: true,
        isSubmitted: true,
      };
    case ADD_PARTNER_CONTACT:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_CONTACT:
      return {
        ...state,
        [action.field]: action.value,
        loading: false,
      };

    default:
      return {
        ...state,
      };
  }
};
